import { useEffect, useState } from 'react';
import { DashboardLayout } from '@shared/infrastructure/ui/layout/dashboardLayout';
import {
  TablePlain,
  TableCell,
  TableRow
} from '@shared/infrastructure/ui/components/table/tablePlain/tablePlain';
import { Therapy } from '@shared/domain/therapy/therapy.aggregate';
import { therapyRepository } from '@shared/domain/therapy/therapy.repository';
import Switch from '@mui/material/Switch';
import { useAppSelector } from '@shared/infrastructure/state/store';
import {
  countryCodeSelector,
  languageCodeSelector
} from '@shared/infrastructure/state/global.slice';
import { PageHeader } from '@shared/infrastructure/ui/components/header/pageHeader';

const Row = ({
  therapy,
  countryCode
}: {
  therapy: Therapy;
  countryCode: string;
}) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(therapy.enabled);

  useEffect(() => {
    setIsEnabled(therapy.enabled);
  }, [therapy.enabled, countryCode]);

  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      aria-label='user table row'
    >
      <TableCell component='th' scope='row'>
        {therapy.nameLanguage}
      </TableCell>
      <TableCell>{therapy.descriptionLanguage}</TableCell>
      <TableCell>{therapy.sectorLanguage}</TableCell>
      <TableCell>
        <Switch
          checked={isEnabled}
          onClick={() => {
            therapyRepository
              .toggleEnableTherapy(therapy.id, countryCode)
              .then(() => setIsEnabled((p) => !p));
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export const TherapiesView = () => {
  const languageCode = useAppSelector(languageCodeSelector);
  const countryCode = useAppSelector(countryCodeSelector);
  const [therapies, setTherapies] = useState<Therapy[] | []>([]);
  useEffect(() => {
    therapyRepository
      .getTherapies(countryCode, languageCode)
      .then((countries) => setTherapies(countries || []));
  }, [countryCode, languageCode]);

  return (
    <DashboardLayout>
      <PageHeader>
        <>Therapies View</>
      </PageHeader>
      <TablePlain<Therapy[]>
        data={therapies}
        headers={['Name', 'Description', 'Sector', 'Enabled']}
      >
        {(data: Therapy[]) =>
          data.map((therapy: Therapy) => (
            <Row
              key={therapy.id}
              therapy={therapy}
              countryCode={countryCode}
            ></Row>
          ))
        }
      </TablePlain>
    </DashboardLayout>
  );
};
